export const OTEL_META_TAG_NAME = 'otel-token'
